import { observer } from 'mobx-react-lite';
import { Outlet } from 'react-router';
import blogSidebarStore from '../blogStores/blogSidebarStore';
import BlogSidebar, { BlogSidebarContent } from './BlogSidebar';
import BlogNavbar from './BlogNavbar';
import { BlogProvider } from './BlogProvider';

const BlogLayout = observer(() => {
    return (
        <BlogProvider>
            <div className="drawer">
                <input
                    id="sidebar"
                    type="checkbox"
                    checked={blogSidebarStore.isOpen}
                    className="drawer-toggle"
                    onChange={(e) => {
                        if (e.target.checked) {
                            blogSidebarStore.openSidebar();
                        } else {
                            blogSidebarStore.closeSidebar();
                        }
                    }}
                />
                <BlogSidebar />
                <div className="drawer-content flex flex-row">
                    <BlogNavbar />
                    <div
                        // 레이아웃 기본
                        // - 가운데 정렬: 최대 800px (max-w-(--main-max-width))
                        // - 최소 높이는 화면 높이 (dvh 는 동적으로 화면 높이를 최대로 조정함)
                        // - 상단 패딩은 안전 높이에 Navbar 높이만큼 추가
                        // - 하단 패딩은 안전 높이에 Dock 높이만큼 추가
                        className="mx-auto min-h-dvh w-full max-w-(--main-max-width) pt-(--navbar-height)"
                    >
                        <div className="floating-sidebar w-(--floating-sidebar-width)">
                            <BlogSidebarContent />
                        </div>
                        <Outlet />
                    </div>
                </div>
            </div>
        </BlogProvider>
    );
});

export default BlogLayout;
